<template>
    <div>
        <b-container fluid="fluid">
            <b-form inline class="mb-2">
                <b-button variant="primary" class="mr-2" :disabled="readonly" @click.prevent="onAddClicked"><fa-icon icon="plus"></fa-icon></b-button>
                <b-select v-model="selectedDashboard" class="mr-2 w-200">
                    <b-form-select-option v-for="d in dashboards" class="mr-2" :value="d" :key="d.id">{{ d.name }}</b-form-select-option>
                </b-select>
                <template v-if="selectedDashboard">
                    <b-form-input v-model.lazy="selectedDashboard.name" class="mr-2 w-200"></b-form-input>
                    <label class="mr-2">
                        <input type="radio" :checked="selectedDashboard.id === defaultDashboardId" @change="setDefaultDashboard"/>&nbsp;als Standard
                    </label>
                    <b-button variant="secondary" @click.prevent="onSaveClicked" class="mr-2" :disabled="readonly"><fa-icon icon="save"></fa-icon></b-button>
                    <b-button variant="danger" @click.prevent="onDeleteClicked" :disabled="readonly"><fa-icon icon="trash"></fa-icon></b-button>
                </template>
            </b-form>
            <div class="dashboard-container">
                <dashboard v-if="selectedDashboard" :id="selectedDashboard.id" v-model="selectedDashboard.configuration" :domain="domain"></dashboard>
            </div>
        </b-container>
    </div>
</template>

<script>
import Dashboard from './Dashboard'
import {request} from "../api";
export default {
    name: "Dashboards",
    props: ['initialDashboards', 'initialDefaultDashboardId', 'domain', 'readonly'],
    data() {
        return {
            selectedDashboard: this.initialDashboards[this.initialDefaultDashboardId] || null,
            defaultDashboardId: this.initialDefaultDashboardId || null,
            dashboards: this.initialDashboards || {}
        }
    },
    components: {Dashboard},
    methods: {
        async onAddClicked() {
            const response = await request(`/dashboards`, {
                method: 'POST',
            })
            const data = await response.json()
            this.dashboards[data.id] = data
            this.selectedDashboard = data
        },
        async onSaveClicked() {
            if (!this.selectedDashboard) return
            await request(`/dashboards/${this.selectedDashboard.id}`, {
                method: 'PATCH',
                body: JSON.stringify(this.selectedDashboard)
            })
        },
        async onDeleteClicked() {
            if (!this.selectedDashboard) return
            const id = this.selectedDashboard.id
            await request(`/dashboards/${id}`, {
                method: 'DELETE'
            })
            Vue.delete(this.dashboards, id)
            this.selectedDashboard = Object.values(this.dashboards)[0] || null
        },
        async setDefaultDashboard() {
            if (!this.selectedDashboard) return
            await request(`/settings/default-dashboard`, {
                method: 'POST',
                body: JSON.stringify({'dashboard-id': this.selectedDashboard.id})
            })

            this.defaultDashboardId = this.selectedDashboard.id
        }
    },
}
</script>

<style scoped>
.w-200 {
    width: 200px;
}
.dashboard-container {
    margin: -10px;
}
</style>
